const replaceQueryParam = (paramSet, search) => {
  const { name, newValue } = paramSet;
  const regex = new RegExp(`([?;&])${name}[^&;]*[;&]?`);
  const query = search.replace(regex, "$1").replace(/&$/, "");
  const queryPrefix = query.length > 2 ? `${query}&` : "?";
  return `${queryPrefix}${name}=${newValue}`;
};
export {
  replaceQueryParam
};
//# sourceMappingURL=replace-query-param.js.map
